import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVimeoThumbnail from 'lightgallery/plugins/vimeoThumbnail';

export function videoGallery() {
    const $lgVideoGalleries = document.querySelectorAll('.cards--video');
    const $videoGalleryItems = document.querySelectorAll('.card--video');

    $lgVideoGalleries?.forEach($gallery => {
        lightGallery($gallery, {
            licenseKey: 'your_license_key',
            plugins: [lgVideo, lgThumbnail, lgVimeoThumbnail],
            selector: '.card__link',
            download: false,
            autoplayFirstVideo: false,
            zoomFromOrigin: false
        });
    });

    $videoGalleryItems?.forEach($el => {
        if ( 'vimeo' == $el.dataset.platform && $el.dataset.vid && !$el.classList.contains('card--has-img-override') ) {
            doVimeoImg($el, $el.dataset.vid);
        }
    });
}


async function doVimeoImg($el = null, vid = null) {
    if ( !$el || !vid ) {
        return;
    }

    const fetchUrl = `https://vimeo.com/api/v2/video/${vid}.json`;

    try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
    
        const resJson = await response.json();
        const vimeoJson = resJson[0];
        const $imgWrap = $el.querySelector('.card__img-wrap');

        if ( $imgWrap && vimeoJson.thumbnail_large ) {
            $imgWrap.innerHTML = $imgWrap.innerHTML + `<img class="objectfit--cover" src="${vimeoJson.thumbnail_large}">`;
        }
        
    } catch (error) {
        console.error(error.message);
    }
}